import "./BlogSec1Availability.css";
import { Image } from "react-bootstrap";
import { FaCalendar } from "react-icons/fa";
import { HiMiniEye } from "react-icons/hi2";
import { useState } from "react";

const BlogSec1Availability = ({ blog, showOnly }) => {
  const [showingAllItems, setShowingAllItems] = useState(false);
  const [visibleTitlesCount, setVisibleTitlesCount] = useState(6);

  // ✅ 1. TABLE OF CONTENT (convert HTML → array)
  const capitalize = (text) =>
    text.charAt(0).toUpperCase() + text.slice(1);

  const decodeHtml = (str) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  };

  const headings =
    blog.tableOfContent
      ?.replace(/<[^>]+>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, " ") // fix nbsp
      .split(",")
      .map((item) => decodeHtml(item.trim())) // ✅ decode entities
      .map((item) => capitalize(item))
      .filter(Boolean) || [];

  // ✅ 2. RECENT POSTS
  const recentPosts = blog.recentPosts || [];

  const handleReadMoreToggle = () => {
    const totalItems = headings.length;

    if (showingAllItems) {
      setVisibleTitlesCount(6);
      setShowingAllItems(false);
    } else {
      setVisibleTitlesCount(totalItems);
      setShowingAllItems(true);
    }
  };

  const clean = (str) =>
    str
      .toLowerCase()
      .replace(/^\d+\.\s*/, "") // remove "1. "
      .replace(/[^a-z0-9 ]/g, "") // remove symbols
      .trim();

  const NAVBAR_OFFSET = 100; // adjust based on your header height

  const handleScroll = (text) => {
    const container = document.querySelector(".durationBoxDiv");
    if (!container) return;

    const elements = container.querySelectorAll("p");
    const target = clean(text);

    for (let el of elements) {
      const content = clean(el.innerText);

      if (content.includes(target)) {
        const y =
          el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_OFFSET;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });

        break;
      }
    }
  };

  // Sections
  const renderTOC = () => (
    <div className="durationBox">
      <div className="inclusionSection">
        <span className="w-100 pb-2 inclusionLabel">Table of content</span>

        <ul className="inclusionLabel-ul">
          {headings.slice(0, visibleTitlesCount).map((item, index) => (
            <li
              key={index}
              onClick={() => handleScroll(item)}
              style={{ cursor: "pointer" }}
            >
              <span className="toc-number">
                {index + 1 < 10 ? `0${index + 1}` : index + 1}.
              </span>{" "}
              {item
                ?.toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}
            </li>
          ))}
        </ul>

        {headings.length > 6 && (
          <div onClick={handleReadMoreToggle} style={{ cursor: "pointer" }}>
            {showingAllItems ? "Read Less" : "Read More"}
          </div>
        )}
      </div>
    </div>
  );

  const renderRecentPosts = () => (
    <div className="mt-4">
      <span className="inclusionLabel2">Recent Posts</span>

      {recentPosts.map((item, index) => (
        <div key={index} className="customCardEven">
          <Image src={item.imageUrl} className="customCardEvenImage" />

          <div className="customCardEvenBody">
            <h3 className="customCardEvenTitle">
              {item.title
                ?.toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}
            </h3>

            <div className="d-flex justify-content-start gap-2 customCardEvenButton">
              <div>
                <FaCalendar /> {new Date(item.date).toLocaleDateString()}
              </div>

              <div>
                <HiMiniEye /> {item.views}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  // Render conditionally for mobile split, or together for desktop
  if (showOnly === "toc") return renderTOC();
  if (showOnly === "recentPosts") return renderRecentPosts();

  return (
    <>
      {renderTOC()}
      {renderRecentPosts()}
    </>
  );
};

export default BlogSec1Availability;